var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "my-5 lg:my-10 2xl:my-15 w-full px-12"
  }, [_vm._v("\n    Curriculum vitae\n  ")]), _vm._v(" "), _vm.listCvs.length === 0 ? _c('no-cv-found', {
    on: {
      "newCV": function (infos) {
        return _vm.createNewCv(infos);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.listCvs.length > 0 ? _c('div', [_c('list-cv', {
    attrs: {
      "list-cvs": _vm.listCvs
    },
    on: {
      "modify": function (cv) {
        _vm.modify(cv);
      },
      "newCV": function (infos) {
        _vm.createNewCv(infos);
      },
      "remove": function (cv) {
        _vm.remove(cv);
      },
      "download": function (cv) {
        _vm.download(cv);
      },
      "dupplicate": function (cv) {
        _vm.dupplicate(cv);
      }
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }